import {Actions, createEffect, ofType} from "@ngrx/effects";
import {inject} from "@angular/core";
import {catchError, map, mergeMap, of, take} from "rxjs";
import {TasksChannelService} from "../services/tasks-channel.service";
import {TasksActions, TasksAPiActions, TasksChannelActions} from "./tasks.actions";
import {Store} from "@ngrx/store";
import {TaskModel} from "../../models/task.model";
import {tasksFeature} from "./tasks.state";
import {TasksHttpService} from "../services/tasks-http.service";

export const getTasks = createEffect(
  (actions$ = inject(Actions),
   tasksHttpService = inject(TasksHttpService)
  ) => {
    return actions$.pipe(
      ofType(TasksAPiActions.getTasks),
      mergeMap(payload => {
        return tasksHttpService.getTasks(payload.taskIds).pipe(
          map((tasksList: TaskModel[]) => {
            return TasksAPiActions.getTasksSuccess({tasks: tasksList})
          }),
          catchError((error: { message: string }) => of(TasksAPiActions.getTasksFailure({error})))
        )
      })
    );
  },
  {functional: true}
);

export const subscribeTasksChannels = createEffect(
  (actions$ = inject(Actions),
   tasksChannelService = inject(TasksChannelService),
   tasksStore = inject(Store<TaskModel>)) => {
    return actions$.pipe(
      ofType(TasksActions.setTasks, TasksAPiActions.getTasksSuccess),
      mergeMap(payload => tasksStore.select(tasksFeature.selectAll).pipe(take(1))),
      map((tasks: TaskModel[]) => {
        const taskIds = tasks.map(t => t.id);
        taskIds.forEach(taskId => tasksChannelService.subscribeById(taskId));
      })
    );
  },
  {functional: true, dispatch: false}
);

export const subscribeAllTasksChannel = createEffect(
  (actions$ = inject(Actions),
   tasksChannelService = inject(TasksChannelService)) => {
    return actions$.pipe(
      ofType(TasksChannelActions.subscribe),
      mergeMap(payload =>
        tasksChannelService.getChannelsValues().pipe(
          map((notification) => {
            return TasksChannelActions.notificationReceived({notification: notification})
          })
        )
      )
    );
  },
  {functional: true}
);

export const unsubscribeAllTaskChannels = createEffect(
  (actions$ = inject(Actions),
   tasksChannelService = inject(TasksChannelService)) => {
    return actions$.pipe(
      ofType(TasksChannelActions.unsubscribe, TasksActions.removeAll),
      map(payload => {
          tasksChannelService.unSubscribeAll();
          return TasksChannelActions.unsubscribeSuccess();
        }
      )
    );
  },
  {functional: true}
);

export const unsubscribeTaskChannels = createEffect(
  (actions$ = inject(Actions),
   tasksChannelService = inject(TasksChannelService)) => {
    return actions$.pipe(
      ofType(TasksActions.removeTasks),
      map(payload => {
          payload.ids?.forEach(taskId => tasksChannelService.unSubscribeById(taskId));
          return TasksChannelActions.unsubscribeSuccess();
        }
      )
    );
  },
  {functional: true}
);
